import React from 'react';
import { Typography } from '@mui/material';
import Product from '../models/Product';
import PriceFormat from './PriceFormat';

const ProductPrice: React.FC<{ product: Product, showPromoPrice?: boolean }> = ({ product, showPromoPrice }) => {



  return (
    <Typography variant="h5" color="primary">
      <span
        style={{
          color: 'red',
          fontSize: '2.1rem',
          fontWeight: 'bold',
        }}
      >
        <PriceFormat amount={product.promoPrice} />
      </span>
      {' '}
      {
        (showPromoPrice && product.promoPrice !== product.price) && (<s style={{ color: 'gray' }}> <PriceFormat amount={product.price} /></s>)
      }

    </Typography>
  );
};

export default ProductPrice;
